module.exports = __webpack_public_path__ + "img/calzone.2b863ccb.jpg";